/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Sales
 * Это Sales api сервер, для запросов от Frontend.  Для запросов требуется указать header с Authorization и типом Bearer.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface Sale2Item
 */
export interface Sale2Item {
  /**
   *
   * @type {string}
   * @memberof Sale2Item
   */
  id: string
  /**
   *
   * @type {string}
   * @memberof Sale2Item
   */
  count: string
  /**
   *
   * @type {string}
   * @memberof Sale2Item
   */
  discount: string
  /**
   *
   * @type {string}
   * @memberof Sale2Item
   */
  priceBuy: string
  /**
   *
   * @type {string}
   * @memberof Sale2Item
   */
  priceOut: string
  /**
   *
   * @type {string}
   * @memberof Sale2Item
   */
  priceDiscount: string
  /**
   *
   * @type {string}
   * @memberof Sale2Item
   */
  priceBuyAll: string
  /**
   *
   * @type {string}
   * @memberof Sale2Item
   */
  priceOutAll: string
  /**
   *
   * @type {string}
   * @memberof Sale2Item
   */
  priceDiscountAll: string
  /**
   *
   * @type {string}
   * @memberof Sale2Item
   */
  saleId: string
  /**
   *
   * @type {string}
   * @memberof Sale2Item
   */
  userId: string
  /**
   *
   * @type {string}
   * @memberof Sale2Item
   */
  itemId: string
  /**
   *
   * @type {number}
   * @memberof Sale2Item
   */
  createdAt: number
  /**
   *
   * @type {number}
   * @memberof Sale2Item
   */
  updatedAt: number
}

/**
 * Check if a given object implements the Sale2Item interface.
 */
export function instanceOfSale2Item(value: object): value is Sale2Item {
  if (!('id' in value) || value['id'] === undefined) return false
  if (!('count' in value) || value['count'] === undefined) return false
  if (!('discount' in value) || value['discount'] === undefined) return false
  if (!('priceBuy' in value) || value['priceBuy'] === undefined) return false
  if (!('priceOut' in value) || value['priceOut'] === undefined) return false
  if (!('priceDiscount' in value) || value['priceDiscount'] === undefined)
    return false
  if (!('priceBuyAll' in value) || value['priceBuyAll'] === undefined)
    return false
  if (!('priceOutAll' in value) || value['priceOutAll'] === undefined)
    return false
  if (!('priceDiscountAll' in value) || value['priceDiscountAll'] === undefined)
    return false
  if (!('saleId' in value) || value['saleId'] === undefined) return false
  if (!('userId' in value) || value['userId'] === undefined) return false
  if (!('itemId' in value) || value['itemId'] === undefined) return false
  if (!('createdAt' in value) || value['createdAt'] === undefined) return false
  if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false
  return true
}

export function Sale2ItemFromJSON(json: any): Sale2Item {
  return Sale2ItemFromJSONTyped(json, false)
}

export function Sale2ItemFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Sale2Item {
  if (json == null) {
    return json
  }
  return {
    id: json['id'],
    count: json['count'],
    discount: json['discount'],
    priceBuy: json['priceBuy'],
    priceOut: json['priceOut'],
    priceDiscount: json['priceDiscount'],
    priceBuyAll: json['priceBuyAll'],
    priceOutAll: json['priceOutAll'],
    priceDiscountAll: json['priceDiscountAll'],
    saleId: json['saleId'],
    userId: json['userId'],
    itemId: json['itemId'],
    createdAt: json['createdAt'],
    updatedAt: json['updatedAt'],
  }
}

export function Sale2ItemToJSON(json: any): Sale2Item {
  return Sale2ItemToJSONTyped(json, false)
}

export function Sale2ItemToJSONTyped(
  value?: Sale2Item | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value
  }

  return {
    id: value['id'],
    count: value['count'],
    discount: value['discount'],
    priceBuy: value['priceBuy'],
    priceOut: value['priceOut'],
    priceDiscount: value['priceDiscount'],
    priceBuyAll: value['priceBuyAll'],
    priceOutAll: value['priceOutAll'],
    priceDiscountAll: value['priceDiscountAll'],
    saleId: value['saleId'],
    userId: value['userId'],
    itemId: value['itemId'],
    createdAt: value['createdAt'],
    updatedAt: value['updatedAt'],
  }
}
